var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgMLfunctionsStandardEnterprise = function SvgMLfunctionsStandardEnterprise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#a61fe0",
    d: "M20 2a18 18 0 100 36 18 18 0 100-36z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8h24v24H8z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.872 17.018a4.573 4.573 0 00-3.825-.92 4.449 4.449 0 00-3.471 3.508A4.393 4.393 0 0017.3 23.97l.1.072a.429.429 0 01.2.319v2.551h4.8v-2.551a.416.416 0 01.19-.311l.103-.075a4.385 4.385 0 00.179-6.957zm-1.415 5.384a2.404 2.404 0 00-1.057 1.959v.552h-.8v-.552a2.447 2.447 0 00-1.108-1.996 2.411 2.411 0 01-.95-2.397 2.467 2.467 0 011.905-1.912 2.586 2.586 0 012.16.512 2.387 2.387 0 01-.15 3.834zm-3.598 5.2h4.282V29H17.86zm-2.152-11.895L15 17l-.707-1.293L13 15l1.293-.707L15 13l.707 1.293L17 15zm3.586-2L18 13l1.293-.707L20 11l.707 1.293L22 13l-1.293.707L20 15zM27 15l-1.293.707L25 17l-.707-1.293L23 15l1.293-.707L25 13l.707 1.293z",
    fill: "#a61fe0"
  })));
};
export default SvgMLfunctionsStandardEnterprise;